import store, { useRecoilState } from '@store';
import { useProduct } from '@backpackjs/storefront';

export const useSelectedVariant = ({ handle } = { handle: null }) => {
  const product = useProduct();
  return useRecoilState(store.selectedVariant(handle || product?.handle));
};
